// Libs
import React from 'react';
import useTheme from 'hooks/useTheme';
// Components
import IconButton from '@mui/material/IconButton';
import Icon from './Edit';

const EditIcon = ({ onClick, onlyIcon, ...buttonProps }) => {
	const { theme } = useTheme();

	return onlyIcon ? (
		<Icon fill={theme._highEmphasisColor} onClick={onClick} />
	) : (
		<IconButton {...buttonProps} onClick={onClick}>
			<Icon fill={theme._highEmphasisColor} />
		</IconButton>
	);
};

export default EditIcon;
